import { useLanguage } from '../context/LanguageContext';
import adminTranslations from '../i18n/adminTranslations';

/**
 * Returns admin UI translations for the CURRENT ADMIN LANGUAGE.
 * Admin language is independent from the public site language.
 * Defaults to English. Switchable to FR or DE only via the sidebar toggle.
 * Falls back to English if the language is not supported.
 */
const useAdminT = () => {
  const { adminLanguage } = useLanguage();
  return adminTranslations[adminLanguage] || adminTranslations.en;
};

export default useAdminT;
